<template>
  <div>
    <div class="hero-slider">
      <div shadow="never" class="card-border">
        <swiper :options="swiperOption">
          <swiper-slide>
            <router-link
                  :to="{
                    name: 'search-products',
                    query: { products: 'IPAD' }
                  }"
                  class="slider-btn"
                  >
              <img
                src="/img/sliders/banners/ipad.png"
                alt="iPads"
                class="img-fluid"
              />
            </router-link>
          </swiper-slide>
          <!-- <swiper-slide>
           
                <router-link
                  :to="{
                    name: 'search-products',
                    query: { products: 'hp spectre' }
                  }"
                  class="slider-btn"
                  > <img
                src="/img/sliders/mobile/2_hp_laptop.jpg"
                alt="HP Laptops"
                class="img-fluid"
              /></router-link
                >
          </swiper-slide> -->
          <swiper-slide>
          
                <router-link
                  :to="{ name: 'search-products', query: { products: 'Apple Watch' } }"
                  class="slider-btn"
                  > <img
                src="/img/sliders/banners/apple-watch.png"
                alt="Ring"
                class="img-fluid"
              /></router-link
                >
          </swiper-slide>
          <swiper-slide>
          
                <router-link
                  :to="{ name: 'search-products', query: { products: 'Iphone' } }"
                  class="slider-btn"
                  > <img
                src="/img/sliders/banners/iphone-14.png"
                alt="LifX"
                class="img-fluid"
              /></router-link
                >
          </swiper-slide>
          <swiper-slide>
      
                <router-link
                  :to="{
                    name: 'search-products',
                    query: { products: 'apple airpods' }
                  }"
                  class="slider-btn"
                  > <img
                src="/img/sliders/banners/airpods.png"
                alt="Air Pods"
                class="img-fluid"
              /></router-link
                >
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      swiperOption: {
        effect: "slide",
        speed: 1500,
        autoplay: {
          delay: 3000
        },
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet(index, className) {
            return `<span class="${className} swiper-pagination-bullet-custom"></span>`;
          }
        }
      }
    };
  }
};
</script>
<style scoped lang="scss">
.hero-slider {
  padding: 0 2em;
  .swiper-pagination {
    bottom: 0;
  }

  @media (max-width: 768px) {
    padding: 0;
  }
}
</style>
